'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Check = function Check(_ref) {
    var isComplete = _ref.isComplete;
    return _react2.default.createElement(
        'div',
        { className: 'complete-tag' },
        _react2.default.createElement('div', { className: isComplete ? 'completed-requirement' : 'incomplete-requirement' })
    );
};

var CheckinDocumentItem = function CheckinDocumentItem(_ref2) {
    var url = _ref2.url,
        isSelected = _ref2.isSelected,
        isComplete = _ref2.isComplete,
        handleClick = _ref2.handleClick,
        requirementSet = _ref2.requirementSet;
    return _react2.default.createElement(
        'tr',
        { className: (0, _classnames2.default)({ 'isSelected': isSelected }) },
        _react2.default.createElement(
            'td',
            { className: 'check-mark' },
            _react2.default.createElement(Check, { isComplete: isComplete })
        ),
        _react2.default.createElement(
            'td',
            { className: 'document-name' },
            _react2.default.createElement(
                'div',
                { onClick: handleClick },
                !isSelected ? _react2.default.createElement(
                    _reactRouter.Link,
                    { to: url },
                    _react2.default.createElement(_components2.TranslatedRequirementSetTitle, { requirementSet: requirementSet })
                ) : _react2.default.createElement(_components2.TranslatedRequirementSetTitle, { requirementSet: requirementSet })
            )
        )
    );
};
CheckinDocumentItem = (0, _pacomo.pacomoTransformer)(CheckinDocumentItem);

var CheckinDocuments = function CheckinDocuments(_ref3) {
    var passengerId = _ref3.passengerId,
        reqSetCode = _ref3.reqSetCode,
        requirementSets = _ref3.requirementSets,
        ui = _ref3.ui,
        updateUI = _ref3.updateUI;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('card', {
                'is-visible': ui.checkinDocumentsIsVisible,
                'is-hidden': !ui.checkinDocumentsIsVisible
            }) },
        _react2.default.createElement(
            'h5',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'checkinDocuments.title', defaultMessage: 'Documents' })
        ),
        _react2.default.createElement(
            'table',
            { className: 'table' },
            _react2.default.createElement(
                'tbody',
                null,

                // TODO: make link less hardcoded?
                requirementSets.map(function (reqSet, i) {
                    return _react2.default.createElement(CheckinDocumentItem, {
                        key: i,
                        url: '/' + passengerId + '/' + reqSet.code,
                        isSelected: reqSet.code === reqSetCode,
                        isComplete: reqSet.reqsComplete === reqSet.totalReqs,
                        handleClick: function handleClick() {
                            if (ui.checkinDocumentsIsVisible) {
                                updateUI('checkinDocumentsIsVisible', false);
                            }
                        },
                        requirementSet: reqSet });
                })
            )
        )
    );
};
CheckinDocuments = (0, _reduxUi2.default)()((0, _pacomo.pacomoTransformer)(CheckinDocuments));

exports.default = CheckinDocuments;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/CheckinDocuments.js
// module id = 1311
// module chunks = 0